import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Flex } from 'reflexbox';
import styled from 'styled-components';

import { Heading } from '@treams/treams-ui';

import * as graphql from 'generated/graphql';

import EmployeesBulkButton from './EmployeesBulkButton';
import EmployeesContextProvider from './EmployeesContextProvider';
import EmployeesFilters from './EmployeesFilters';
import EmployeesList from './EmployeesList';
import useFeature from 'packages/kakapo-ui-application/hooks/useFeature';

const Split = styled.div`
	display: flex;
	flex-direction: row;
	flex-grow: 1;
`;

const Main = styled.div`
	display: flex;
	flex-direction: column;
	flex: 0.7;
	flex-shrink: 1;
	overflow: hidden;
	overflow-x: scroll;
`;

const Sidebar = styled.div`
	background: ${(props) => props.theme.colors.lightBlueLight};
	flex: 0.3;
	padding: 20px;
	flex-shrink: 0;
`;

export function EmployeesContainerWithoutSidebar() {
	const { t } = useTranslation();

	const [selected, setSelected] = useState<graphql.User[]>([]);

	const hasCyclesFilter = useFeature(graphql.FeatureName.EmployeesFiltersCycles);
	const hasJobsFilter = useFeature(graphql.FeatureName.EmployeesFiltersJobs);

	return (
		<EmployeesContextProvider>
			<Split>
				<Main>
					<Flex p={20} alignItems="center" style={{ height: '70px' }} flexGrow={0} flexShrink={0}>
						<Box flexGrow={1} flexShrink={1}>
							<Heading>{t('common.organization.employeeList.title')}</Heading>
						</Box>
						{selected.length > 0 && (
							<Box marginLeft={10} flexGrow={0} flexShrink={0}>
								<EmployeesBulkButton selection={selected} />
							</Box>
						)}
					</Flex>
					<EmployeesList selection={selected} onChange={setSelected} />
				</Main>
				<Sidebar>
					<EmployeesFilters cycles={hasCyclesFilter} jobs={hasJobsFilter} />
				</Sidebar>
			</Split>
		</EmployeesContextProvider>
	);
}
